import { render } from "./StreamsWidget.vue?vue&type=template&id=df0b2a68&scoped=true"
import script from "./StreamsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsWidget.vue?vue&type=script&setup=true&lang=js"

import "./StreamsWidget.vue?vue&type=style&index=0&id=df0b2a68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0b2a68"],['__file',"src/components/ui/StreamsWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df0b2a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df0b2a68', __exports__)) {
    api.reload('df0b2a68', __exports__)
  }
  
  module.hot.accept("./StreamsWidget.vue?vue&type=template&id=df0b2a68&scoped=true", () => {
    api.rerender('df0b2a68', render)
  })

}


export default __exports__